import {breakpoint, assets_path} from '@/_constant/variables';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  os: '',
  current: 0,
};

const mutations = {
  setOS(state) {
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf("mac os x") !== -1) {
      state.os = 'mac';
    }
  },
  setCurrent(num) {
    state.current = num;
  },
};

const getters = {
  getOS: (state) => {
    return state.os;
  },
  getCurrent: (state) => {
    return state.current;
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations
});